import React, { useEffect, useState } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  FolderIconBlue,
  ArrowUpRightBlue,
  FolderIconCheckDoneBlue
} from "../../../../constant/imagePath";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon.jsx";
import classes from "./BackgroundCheck.module.css";
import BackgroundCheckMobile from "./BackgroundCheckMobile";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import { ReactSVG } from "react-svg";
import PageProgressBar from "../../../../stories/PageProgressBar/PageProgressBar";
import { setPersonalData } from "../../../../store/Actions/authAction";
import { useDispatch, useSelector } from "react-redux";

function BackgroundCheckDesktop({ stepForwardAndBackward }) {
  const history = useHistory();
  const getDataFromRedux = useSelector(
    (state) => state.onBoardingReducer?.backgroundCheck
  );

  const [checkInfo, setCheckInfo] = useState(getDataFromRedux ? getDataFromRedux : false);
  const dispatch = useDispatch();

  // Save And Finish Later
  function saveAndFinishLater() {
    dispatch(setPersonalData("background-check", checkInfo));
  }

  console.log({checkInfo})

  return (
    <div className={classes.backgroundCheck}>
      <div className={classes.progressLine}>
        <PageProgressBar progress={'33.3%'} />
      </div>
      <Row className={`g-0 ${classes.row}`}>
        <Col md={12}>
          <Col md={12} className={`${[classes.saveAndFinish].join(" ")}`}>
            <LinkButtonWithIcon
              text={"Save and Finish Later"}
              customStyle={{
                color: Colors.neutralShadesOfNero,
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              onClick={saveAndFinishLater}
            />
          </Col>

          <Col md={12} className={` ${classes.innerContainer}`}>
            <h3 style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}>
              Background Check
            </h3>

            <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
              We need to check some information about you before posting your
              profile on our site.
            </p>
          </Col>
          {/*  */}
          {checkInfo ? (
            <Col
              md={12}
              style={{ marginTop: "58px" }}
              className={classes.innerContainer}
            >
              <div
                className={classes.startBackgroundCheckbox}
                style={{
                  border: `1px solid ${Colors.neutralShadesOfWhisper}`,
                  height: "292px",
                }}
              >
                <div className={classes.boxContent}>
                  <ReactSVG src={FolderIconCheckDoneBlue} beforeInjection={(svg) => {
                    svg.classList.add(classes.img)
                  }} />
                  <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
                    We will check your background info as soon as possible.
                  </p>

                  <div>
                    <LinkButtonWithIcon
                      text={"Change background info"}
                      primary={true}
                      rightIcon={ArrowUpRightBlue}
                      iconStyle={{
                        width: "16px",
                        height: "16px",
                        margin: "auto",
                        marginLeft: "0px",
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          ) : (
            <Col
              md={12}
              style={{ marginTop: "58px" }}
              className={classes.innerContainer}
            >
              <div
                className={classes.startBackgroundCheckbox}
                style={{
                  border: `1px solid ${Colors.neutralShadesOfWhisper}`,
                }}
              >
                <div className={classes.boxContent}>
                  <ReactSVG src={FolderIconBlue} beforeInjection={(svg) => {
                    svg.classList.add(classes.img)
                  }} />

                  <div className={classes.title}>
                    <LinkButtonWithIcon
                      text={"Start background check"}
                      rightIcon={ArrowUpRightBlue}
                      primary={true}
                      iconStyle={{
                        width: "16px",
                        height: "16px",
                        margin: "auto",
                        marginLeft: "0px",
                      }}
                      onClick={() => setCheckInfo(true)}
                    />
                  </div>
                </div>
              </div>
            </Col>
          )}
        </Col>
        <Col
          md={12}
          style={{
            borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
          className={classes.btnsCol}
        >
          <div className={classes.btnsBox}>
            <Button
              label={"Back"}
              size={"Large"}
              customStyle={{ width: "162px", height: "56px" }}
              onClick={() => stepForwardAndBackward(1, 1)}
            />
            <Button
              label={"Next"}
              primary={true}
              size={"Large"}
              customStyle={{ width: "162px", height: "56px" }}
              onClick={() => {
                saveAndFinishLater()
                stepForwardAndBackward(2, 1)}}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default function BackgroundCheck({ stepForwardAndBackward }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? (
    <BackgroundCheckMobile stepForwardAndBackward={stepForwardAndBackward} />
  ) : (
    <BackgroundCheckDesktop stepForwardAndBackward={stepForwardAndBackward} />
  );
}
